import { ActiveInvestmentsMenuIcon } from '@/assets/icons/menu-icons/activeInvestments';
import { AllocationsMenuIcon } from '@/assets/icons/menu-icons/allocations';
import { ComplianceMenuIcon } from '@/assets/icons/menu-icons/compliance';
import { DealPipelineMenuIcon } from '@/assets/icons/menu-icons/dealPipeline';
import { DueDiligenceMenuIcon } from '@/assets/icons/menu-icons/dueDiligence';
import { InvestorsMenuIcon } from '@/assets/icons/menu-icons/investors';
import { ManagerUpdatesMenuIcon } from '@/assets/icons/menu-icons/managerUpdates';
import { PendingCommitmentsMenuIcon } from '@/assets/icons/menu-icons/pendingCommitments';
import { ReportingDataMenuIcon } from '@/assets/icons/menu-icons/reportingData';
import { SettingsMenuIcon } from '@/assets/icons/menu-icons/settings';
import { ToDoMenuIcon } from '@/assets/icons/menu-icons/todo';
import { SidebarTabs } from '@/shared/types/sidebarTabs';

export const allSidebarTabs: SidebarTabs[] = [
  {
    label: 'To Do',
    path: 'todo',
    icon: <ToDoMenuIcon style={{ minWidth: '28px' }} />
  },
  {
    label: 'Manager Pipeline',
    path: 'dealPipeline',
    subTitle: 'Control when and how strategies appear to advisors',
    icon: <DealPipelineMenuIcon style={{ minWidth: '28px' }} />
  },
  {
    label: 'Due Diligence',
    subTitle: '',
    path: 'dueDiligence',
    icon: <DueDiligenceMenuIcon style={{ minWidth: '28px' }} />
  },
  {
    label: 'Manager Pipeline',
    path: 'dealCatalog',
    icon: <AllocationsMenuIcon style={{ minWidth: '28px' }} />
  },
  {
    label: 'Investors',
    path: 'investors',
    subTitle: 'Find and view each investor within your firm.',
    icon: <InvestorsMenuIcon style={{ minWidth: '28px' }} />
  },
  {
    label: 'Pending Commitments',
    subTitle: 'Manage all tasks to finalize private capital transactions',
    path: 'pendingCommitments',
    icon: <PendingCommitmentsMenuIcon style={{ minWidth: '28px' }} />
  },
  {
    label: 'Transactions',
    subTitle: 'Complete investor documentation and collect signatures to finalize private capital transactions.',
    path: 'transactions',
    icon: <PendingCommitmentsMenuIcon style={{ minWidth: '28px' }} />
  },
  {
    label: 'Active Commitments',
    subTitle: 'Search  across all managers where you have active investments',
    path: 'activeInvestments',
    icon: <ActiveInvestmentsMenuIcon style={{ minWidth: '28px' }} />
  },
  {
    label: 'Manager Updates',
    subTitle: 'Log all quarterly updates',
    path: 'managerUpdates',
    icon: <ManagerUpdatesMenuIcon style={{ minWidth: '28px' }} />
  },
  {
    label: 'Reporting Data',
    subTitle: 'Obtain a capital activity upload formated for your reporting system',
    path: 'reportingData',
    icon: <ReportingDataMenuIcon style={{ minWidth: '28px' }} />
  },
  {
    label: 'Compliance',
    path: 'compliance',
    icon: <ComplianceMenuIcon style={{ minWidth: '28px' }} />
  },
  {
    label: 'Settings',
    path: 'settings',
    icon: <SettingsMenuIcon style={{ minWidth: '28px' }} />
  }
];
